import React, { useState, useEffect } from "react";
import PowerBiReport from "../Utils/Powerbi_client";

const PageDataViewData = () => {
  const [height, setHeight] = useState(600);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setHeight(800);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <div className="dataBoard">
      <div className="dataAnalyseBoard">
        {/* <PowerBiReport
          reportId={process.env.REACT_APP_PATIENT_DATA_REPORT_ID}
          embedUrl={process.env.REACT_APP_PATIENT_DATA_EMBED_URL}
          accessToken={process.env.REACT_APP_ACCESS_TOKEN}
          pageNavigation={false}
        /> */}
        <iframe
          title="patient data view"
          width="1200"
          height={height}
          src="https://app.powerbi.com/reportEmbed?reportId=62928e12-2646-4d78-89c8-babf329dcd9b&autoAuth=true&ctid=f8300747-02c3-470c-a3d6-5a3355e3d77d&navContentPaneEnabled=false&filterPaneEnabled=false"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  );
};

export default PageDataViewData;
